import axios from 'axios'
import router from '../router'
import qs from 'qs'
import { getToken } from './common'
// import { BASE_URL, BASE_URL_PROD } from './config'
import { Message, Loading } from 'element-ui'

const config = require('./_config_' + process.env.NODE_ENV)
let loadingInstance

const http = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  let token = getToken()
  if (token !== null) {
    config.headers['token'] = token
  }
  loadingInstance = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(243, 243, 243, 0.1)'
  })
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  loadingInstance.close()
  if (response.data.success === false) {
    if (response.data.errorMessage != null) {
      Message.error(response.data.errorMessage)
    }
    let err = {
      code: response.data.resultCode,
      message: response.data.errorMessage
    }
    throw err
  }
  return response.data
}, error => {
  loadingInstance.close()
  Message.error('您当前的网络状况不佳，请稍后再试')
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  // 非生产环境
  return config.BASE_URL + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {}
  return openDefultParams ? Object.assign({}, defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, contentType = 'json') => {
  if (contentType === 'form') {
    http.defaults.headers['Content-Type'] = 'multipart/form-data'
    return data
  }
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http



// WEBPACK FOOTER //
// ./src/util/request.js